import { INotification, TIssueStatus } from "@mctypes/global.types";
import { apiSlice } from "../apiSlice";
import { setNotificationInRedux } from "../global/globalSlice";
import { trpcSlice } from "../trpcSlice";

export const notificationRTK = trpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationIssueStatuses: builder.query<
      { issueId: string; status: TIssueStatus }[],
      { issueIds: string[] }
    >({
      query: (body) => ({
        url: "/notifications/issue-statuses",
        method: "POST",
        body,
      }),
      providesTags: ["NotificationIssueStatuses"],
    }),
  }),
});

export const { useGetNotificationIssueStatusesQuery } = notificationRTK;

export const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<INotification[], void>({
      query: () => ({
        url: "/user/notifications",
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setNotificationInRedux(data));
        } catch (error) {
          console.error("Failed to refresh notifications", error);
        }
      },
      providesTags: ["Notifications"],
    }),
  }),
});

export const { useGetNotificationsQuery } = notificationApi;
